module.exports = __webpack_public_path__ + "img/loginBollitsWhite.2d2238b3.png";